import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import { MenuItem } from 'primeng/api';

import { EnvironmentService } from '@core/services';

import { AuthService } from '@auth/services';
import { AuthActions } from '@auth/state';

@Injectable({
  providedIn: 'root',
})
export class DeveloperService {
  contextMenuItems$ = new BehaviorSubject<MenuItem[]>([]);

  constructor(
    private authService: AuthService,
    private environmentService: EnvironmentService,
    private router: Router,
    private store: Store
  ) {
    if (this.environmentService.environment.production) {
      this.contextMenuItems$.next([]);
      return;
    }

    const items: MenuItem[] = [
      {
        label: 'Developer Menu',
        disabled: true,
      },
      {
        separator: true,
      },
      {
        label: 'Toggle Theme',
        command: () => this.toggleTheme(),
      },
      {
        label: 'Toggle Language',
        command: () => this.toggleLanguage(),
      },
      {
        label: 'Force Session Timeout',
        command: () => {
          this.store.dispatch(AuthActions.SetAuthenticated({ authenticated: false }));
        },
      },
      {
        separator: true,
      },
      {
        label: 'Clear State',
        command: () => this.clearState(),
      },
    ];

    this.contextMenuItems$.next(items);
  }

  clearState() {
    void this.router.navigate(['login']);

    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      this.store.dispatch(AuthActions.ResetState());
      window.location.reload();
    }, 50);
  }

  toggleTheme() {
    this.authService.toggleTheme();
  }

  toggleLanguage() {
    this.authService.language$
      .pipe(
        filter((x) => !!x),
        take(1)
      )
      .subscribe((language) => {
        if (language === 'en') {
          this.authService.setLanguage('es');
        } else {
          this.authService.setLanguage('en');
        }
      });
  }
}
